export const IDENTITO_BASE_URL_QA = 'https://identito-qa-stable.ext.np.midasplayer.cloud';
export const IDENTITO_BASE_URL_LIVE = 'https://identity.king.com';

export const IDENTITO_CLIENT_ID_QA = 'soporto-qa';
export const IDENTITO_CLIENT_ID_LIVE = 'soporto';

export const SOPORTO_HOSTS_QA = [
    'soportoqa.midasplayer.com',
    'soporto-qa.ext.np.midasplayer.cloud',
    'soporto-qa.int.np.midasplayer.cloud'
];
export const SOPORTO_HOSTS_LIVE = [
    'soporto.king.com',
    'soporto-live.ext.p.midasplayer.cloud',
    'soporto-live.int.p.midasplayer.cloud'
];



// WEBPACK FOOTER //
// ./src/components/Login/constants.js